import { useState, useEffect } from "react";
import Image from "next/image";
import classNames from "classnames";
import ImgixLoader from "@utils/images/ImgixLoader";

function ProductImage({ src, sizes = "64px", className, ...props }) {
  const [imageLoaded, setImageLoaded] = useState(false);

  function imageLoadedHandler() {
    setImageLoaded(true);
  }

  useEffect(() => {
    setImageLoaded(false);
  }, [src]);

  return (
    <div className={classNames("product-image-container", className)}>
      {src && (
        <Image
          loader={ImgixLoader}
          src={src}
          alt=""
          onLoadingComplete={imageLoadedHandler}
          fill
          sizes={sizes}
          className={classNames("product-image", imageLoaded && "loaded")}
          {...props}
        />
      )}
    </div>
  );
}

export default ProductImage;
